import MUISwitch from '@material-ui/core/Switch';

const Toggle = props => {
  const { className, style, onChange, checked, color, disabled, ...rest } =
    props;

  return (
    <MUISwitch
      className={className}
      style={style}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      color={color || 'primary'}
      {...rest}
    />
  );
};

export default Toggle;
